// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file whatsapp_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { WhatsappMessageListSchema, WhatsappMessageSchema } from "./whatsapp_pb";
import { file_whatsapp } from "./whatsapp_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file whatsapp_service.proto.
 */
export const file_whatsapp_service: GenFile = /*@__PURE__*/
  fileDesc("ChZ3aGF0c2FwcF9zZXJ2aWNlLnByb3RvEglyYWNjb29uYWkiUQoXV2hhdHNhcHBNZXNzYWdlc1JlcXVlc3QSFgoGam9iX2lkGAEgASgEUgZqb2JfaWQSHgoKY29udGFjdF9pZBgCIAEoBFIKY29udGFjdF9pZCJwChpTZW5kV2hhdHNhcHBNZXNzYWdlUmVxdWVzdBIWCgZqb2JfaWQYASACKARSBmpvYl9pZBIMCgRib2R5GAIgAigJEiwKEWNsaWVudF9tZXNzYWdlX2lkGAMgAigJUhFjbGllbnRfbWVzc2FnZV9pZDLLAQoPV2hhdHNhcHBTZXJ2aWNlElwKFExpc3RXaGF0c2FwcE1lc3NhZ2VzEiIucmFjY29vbmFpLldoYXRzYXBwTWVzc2FnZXNSZXF1ZXN0Gh4ucmFjY29vbmFpLldoYXRzYXBwTWVzc2FnZUxpc3QiABJaChNTZW5kV2hhdHNhcHBNZXNzYWdlEiUucmFjY29vbmFpLlNlbmRXaGF0c2FwcE1lc3NhZ2VSZXF1ZXN0GhoucmFjY29vbmFpLldoYXRzYXBwTWVzc2FnZSIAQgZaBC4vcGI", [file_whatsapp]);

/**
 * @generated from message raccoonai.WhatsappMessagesRequest
 */
export type WhatsappMessagesRequest = Message<"raccoonai.WhatsappMessagesRequest"> & {
  /**
   * @generated from field: optional uint64 job_id = 1 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * @generated from field: optional uint64 contact_id = 2 [json_name = "contact_id"];
   */
  contactId: bigint;
};

/**
 * @generated from message raccoonai.WhatsappMessagesRequest
 */
export type WhatsappMessagesRequestJson = {
  /**
   * @generated from field: optional uint64 job_id = 1 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: optional uint64 contact_id = 2 [json_name = "contact_id"];
   */
  contact_id?: string;
};

/**
 * Describes the message raccoonai.WhatsappMessagesRequest.
 * Use `create(WhatsappMessagesRequestSchema)` to create a new message.
 */
export const WhatsappMessagesRequestSchema: GenMessage<WhatsappMessagesRequest, {jsonType: WhatsappMessagesRequestJson}> = /*@__PURE__*/
  messageDesc(file_whatsapp_service, 0);

/**
 * A dispatcher's free-text message to the client of a job's WhatsApp dialogue.
 *
 * @generated from message raccoonai.SendWhatsappMessageRequest
 */
export type SendWhatsappMessageRequest = Message<"raccoonai.SendWhatsappMessageRequest"> & {
  /**
   * @generated from field: required uint64 job_id = 1 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * @generated from field: required string body = 2;
   */
  body: string;

  /**
   * Generated by the sender per message; a repeat returns the first send's message.
   *
   * @generated from field: required string client_message_id = 3 [json_name = "client_message_id"];
   */
  clientMessageId: string;
};

/**
 * A dispatcher's free-text message to the client of a job's WhatsApp dialogue.
 *
 * @generated from message raccoonai.SendWhatsappMessageRequest
 */
export type SendWhatsappMessageRequestJson = {
  /**
   * @generated from field: required uint64 job_id = 1 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: required string body = 2;
   */
  body?: string;

  /**
   * Generated by the sender per message; a repeat returns the first send's message.
   *
   * @generated from field: required string client_message_id = 3 [json_name = "client_message_id"];
   */
  client_message_id?: string;
};

/**
 * Describes the message raccoonai.SendWhatsappMessageRequest.
 * Use `create(SendWhatsappMessageRequestSchema)` to create a new message.
 */
export const SendWhatsappMessageRequestSchema: GenMessage<SendWhatsappMessageRequest, {jsonType: SendWhatsappMessageRequestJson}> = /*@__PURE__*/
  messageDesc(file_whatsapp_service, 1);

/**
 * @generated from service raccoonai.WhatsappService
 */
export const WhatsappService: GenService<{
  /**
   * @generated from rpc raccoonai.WhatsappService.ListWhatsappMessages
   */
  listWhatsappMessages: {
    methodKind: "unary";
    input: typeof WhatsappMessagesRequestSchema;
    output: typeof WhatsappMessageListSchema;
  },
  /**
   * Sends inside WhatsApp's 24-hour window only; puts the dialogue in operator
   * mode, so the client's replies reach the dispatcher instead of the bot.
   *
   * @generated from rpc raccoonai.WhatsappService.SendWhatsappMessage
   */
  sendWhatsappMessage: {
    methodKind: "unary";
    input: typeof SendWhatsappMessageRequestSchema;
    output: typeof WhatsappMessageSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_whatsapp_service, 0);

